const HUB_USER_COOKIE_NAME = 'hub-user';

/**
 * Used to determine if we should try and fetch a user session on load or not
 * @returns boolean
 */
export function tryFetchHubSession(): boolean {
  return getHubUserCookieValue() === 'true';
}

/**
 * Sets a session cookie for HUB
 * @param value boolean, is user logged in or not
 */
export function setHubUserCookie(value: boolean): void {
  document.cookie = HUB_USER_COOKIE_NAME + '=' + String(value) + ';' + 'path=/';
}

/**
 * Gets the session cookie for HUB, taken from MDN
 * @returns string | undefined, value of cookie
 */
export function getHubUserCookieValue(): string | undefined {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(HUB_USER_COOKIE_NAME + '='))
    ?.split('=')[1];
}
